import React, { useCallback, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Button, Layout, Tooltip, Typography } from "antd";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import ArrowBack from "../assets/svg/ArrowBack.js";

import ACTIONS from "../store/action";
import { RecentPatientsTable } from "../component/RecentPatientsTable.js";
import { selectRecentPatients } from "@tailormed/common-client/store/reselectSelector";
import { selectSearchResultCurrentPage, selectIsFetching } from "../store/selector";
import { ApiNames, getPharmacyPatientByIdAPI } from "../api/api";
import styled from "styled-components";
import ErrorMessage from "../component/customComponent/customMessages/ErrorMessage.js";
import { isModifierClick } from "../utils/misc.js";

const { Content } = Layout;
const { Text } = Typography;

const BackButtonStyle = styled(Button)`
  background-color: transparent;
  border: none;
  padding: 0;
`;

const RecentPatientsComponent = ({ t, history, recentPatientsAct, setPatientModal }) => {
  const dispatch = useDispatch();
  const [startFetch, setStartFetch] = useState(false);

  const setPatientAct = (pharmacyPatient, patientId, orderId) =>
    dispatch(ACTIONS.setPatientAction(pharmacyPatient, patientId, orderId));
  const setCurrentCycle = (currentCycle) => dispatch(ACTIONS.setCurrentCycle(currentCycle));
  const currentPage = useSelector(selectSearchResultCurrentPage);
  const recentPatients = useSelector(selectRecentPatients);

  const { patients = [], total } = recentPatients || {};

  useEffect(() => {
    debouncedFetch(1);
  }, []);

  const debouncedFetch = useCallback(
    debounce((page) => {
      setStartFetch(true);
      recentPatientsAct(page);
    }, 500),
    []
  );

  const getPharmacyPatientById = async (pharmacyPatient) => {
    const { data } = await getPharmacyPatientByIdAPI(pharmacyPatient);
    return data;
  };

  const onClickTable = () => ({
    onCell: (pharmacyPatient) => ({
      onClick: async (e) => {
        if (isModifierClick(e)) {
          return;
        }

        try {
          const { id } = pharmacyPatient;
          setPatientModal(true, 0);
          const pharmacyPatientData = await getPharmacyPatientById(id);
          setCurrentCycle({
            ...pharmacyPatientData,
            pharmacyPatientCurrentOrder: pharmacyPatient.currentOrder.id
          });
          setPatientAct(id, pharmacyPatient.patient.id, pharmacyPatientData.currentOrder.id);
        } catch (error) {
          ErrorMessage(t("errorMessages.failed_to_fetching_patient_data"));
        }
      }
    })
  });

  return (
    <Content style={{ backgroundColor: "white" }}>
      <div
        style={{
          background: "#f5f5f5",
          padding: "8px 52px",
          borderBottom: "1px solid #d4d4d5",
          marginBottom: 16
        }}
      >
        <Tooltip title={t("back")}>
          <BackButtonStyle onClick={() => history.goBack()} type="text">
            <ArrowBack />
          </BackButtonStyle>
        </Tooltip>
        <div>
          <Text style={{ fontWeight: "700", color: "#525055" }}>{t("recent_patients")}</Text>
        </div>
      </div>
      <RecentPatientsTable
        fetchOrders={(page) => debouncedFetch(page)}
        patients={startFetch ? patients : []}
        startFetch={startFetch}
        total={total}
        onClickTable={onClickTable}
        searchInput={""}
        currentPage={currentPage}
      />
    </Content>
  );
};

const mapStateToProps = createStructuredSelector({
  isFetching: selectIsFetching([ApiNames.SearchFreeText])
});

const mapDispatchToProps = (dispatch) => ({
  recentPatientsAct: (page) => dispatch(ACTIONS.getRecentPatientsAction(page)),
  setPatientModal: (show, tab) => dispatch(ACTIONS.setShowPatientModal(show, tab))
});

const RecentPatients = compose(
  withRouter,
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(RecentPatientsComponent);
export { RecentPatients };
